var fullMenuWidth = "320px";
var builderNav = {
    base: {
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0,
        width: fullMenuWidth,
        height: "100%",
        font: "body",
        alignContent: "start",
        transition: "width ease-out, left ease-out",
        transitionDuration: 6,
        bg: "black.2",
    },
};
var builderNavSection = {
    base: {
        boxSizing: "border-box",
        px: 7,
        py: 5,
        borderBottom: "1px solid",
        borderBottomColor: "black.10",
        fontSize: 2,
    },
};
var builderNavHeader = {
    base: {
        boxSizing: "border-box",
        display: ["flex", "grid"],
        gridTemplateColumns: "max-content 1fr max-content",
        columnGap: 1,
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        pt: "40px",
        pb: "24px",
        px: "24px",
        borderBottom: "1px solid",
        borderBottomColor: "black.10",
        "[data-ui-logo-mark]": {
            fontSize: "iconMd",
        },
    },
};
var builderNavSkipLink = {
    base: {
        bg: "black.2",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
};
var builderNavItems = {
    base: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gridRowGap: 3,
        bg: "black.2",
        px: 3,
        pt: "16px",
    },
};
var builderNavNotifyDot = {
    base: {
        color: "critical.100",
        position: "relative",
        right: "calc(1em / 3)",
        "&[data-notify-dot-collapsed=true]": {
            opacity: 0,
        },
    },
};
var builderNavItem = {
    base: {
        font: "body",
        alignItems: "center",
        justifyItems: "start",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
        gridAutoColumns: "min-content",
        gridAutoRows: "min-content",
        columnGap: "0.5rem",
        minWidth: 0,
        textDecoration: "none",
        whiteSpace: "nowrap",
        borderWidth: 0,
        borderRadius: 3,
        height: "56px",
        "&[data-with-description]": { height: "82px" },
        px: "32px",
        bg: "black.2",
        color: "black.80",
        cursor: "pointer",
        "&[data-current], &[aria-current]": {
            bg: "black.5",
        },
        "&[data-current] > [data-label], &[aria-current] > [data-label]": {
            color: "black.100",
            fontWeight: "bold",
        },
        "&[data-current] > [data-icon], &[aria-current] > [data-icon]": {
            color: "black.100",
        },
        ":hover:not([data-disabled=true])": {
            bg: "black.5",
            textDecoration: "none",
        },
        "&[data-disabled=true]": {
            color: "black.40",
            cursor: "default",
        },
        "[data-icon]": { lineHeight: 0, fontSize: "18px" },
        "[data-description]": {
            fontSize: "sm",
            lineHeight: 1,
            alignSelf: "flex-start",
            marginBottom: 4,
        },
    },
};
var builderNavMenu = {
    base: {
        font: "body",
        alignItems: "center",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridAutoColumns: "min-content",
        columnGap: "0.5rem",
        justifyItems: "start",
        minWidth: 0,
        whiteSpace: "nowrap",
        textDecoration: "none",
        borderWidth: 0,
        height: "56px",
        px: "32px",
        bg: "black.2",
        color: "black.80",
        cursor: "pointer",
        "&[data-current], &[data-is-open=true]": {
            bg: "black.5",
        },
        "&[data-current][data-is-open=true]": {
            color: "black.100",
        },
        ":hover:not([data-disabled=true])": {
            color: "black.100",
            bg: "black.5",
            textDecoration: "none",
        },
        "&[data-disabled=true]": {
            color: "black.40",
            cursor: "default",
        },
        "[data-icon]": { lineHeight: 0, fontSize: "18px" },
        "[data-description]": {
            fontSize: "sm",
            lineHeight: 1,
            alignSelf: "flex-start",
            marginBottom: 4,
        },
    },
};
var builderNavMenuItems = {
    base: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: 3,
        bg: "black.2",
        py: 3,
        mt: 1,
    },
};
var builderNavMenuItem = {
    base: {
        font: "body",
        alignItems: "center",
        // display: "flex",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
        gridAutoColumns: "min-content",
        gridAutoRows: "min-content",
        columnGap: "0.5rem",
        justifyItems: "start",
        minWidth: 0,
        whiteSpace: "nowrap",
        textDecoration: "none",
        borderWidth: 0,
        borderRadius: 3,
        height: "56px",
        px: "32px",
        pl: "48px",
        bg: "black.2",
        color: "black.80",
        cursor: "pointer",
        "&[data-disabled=true]": {
            cursor: "default",
        },
        "&[data-current] > [data-label], &[aria-current] > [data-label]": {
            color: "black.100",
        },
        "&[data-with-description]": { height: "82px" },
        ":hover:not([data-disabled=true])": {
            bg: "black.5",
            textDecoration: "none",
        },
        "[data-icon]": { lineHeight: 0, fontSize: "18px", mr: 3 },
        "[data-description]": {
            fontSize: "sm",
            lineHeight: 1,
            alignSelf: "flex-start",
            marginBottom: 4,
        },
    },
};
var builderNavToggle = {
    base: {
        display: ["none", "block"],
        color: "brandDark.40",
        justifySelf: "end",
        ":hover": { color: "white" },
    },
};

export { builderNav, builderNavHeader, builderNavItem, builderNavItems, builderNavMenu, builderNavMenuItem, builderNavMenuItems, builderNavNotifyDot, builderNavSection, builderNavSkipLink, builderNavToggle };
//# sourceMappingURL=builder-nav.js.map
